import { createContext, useCallback, useContext, useMemo, useState } from "react";
import SnackBar from "./Snackbar";

const SnackbarContext = createContext(null);

export function SnackbarProvider({ children }) {
  const [snackbar, setSnackbar] = useState({
    open: false,
    title: "",
    subtitle: "",
    type: "success",
  });

  const hide = useCallback(() => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  }, []);

  const show = useCallback(({ title, subtitle, type = "success" }) => {
    setSnackbar({ open: true, title, subtitle, type });
  }, []);

  const showSuccess = useCallback(
    (title, subtitle = "") => show({ title, subtitle, type: "success" }),
    [show]
  );

  const showError = useCallback(
    (title, subtitle = "") => show({ title, subtitle, type: "error" }),
    [show]
  );

  const value = useMemo(
    () => ({ show, showSuccess, showError, hide }),
    [show, showSuccess, showError, hide]
  );

  return (
    <SnackbarContext.Provider value={value}>
      {children}
      {snackbar.open && (
        <div className="notification">
          <SnackBar
            state={snackbar.open}
            setState={(next) => {
              if (!next) hide();
            }}
            title={snackbar.title}
            subtitle={snackbar.subtitle}
            module={snackbar.type}
            action={snackbar.type}
          />
        </div>
      )}
    </SnackbarContext.Provider>
  );
}

export function useSnackbar() {
  const context = useContext(SnackbarContext);
  if (!context) {
    throw new Error("useSnackbar must be used within SnackbarProvider");
  }
  return context;
}
